import {AbstractControl, ValidationErrors, ValidatorFn} from '@angular/forms';
import {MappingRule, Operand} from '@em/shared/mapping-engine/domain-models';

export function mappingRuleValidator(): ValidatorFn {
  return (control: AbstractControl): ValidationErrors | null => {
    const mappingRule = control.value as MappingRule;

    if (!mappingRule.mappingType) {
      return {mappingRule: true};
    }

    switch (mappingRule.mappingType) {
      case 'leave_empty':
        return null;
      case 'attribute':
        return (mappingRule.mappingValue as Operand)?.value
          ? null
          : {mappingRule: true};
      case 'combine_attributes':
        return (mappingRule.mappingValue as Operand[])?.length
          ? null
          : {mappingRule: true};
      default:
        return null;
    }
  };
}
